export const MODES = [
  ["best", "Melhor aproveitamento", "Menos chapas, sobra onde ficar melhor"],
  ["vertical", "Sobra na vertical", "Deixa a sobra em faixa em pé"],
  ["horizontal", "Sobra na horizontal", "Deixa a sobra em faixa deitada"],
];

const pct = (v) => `${v.toFixed(2).replace(".", ",")}%`;

export const PlanModePicker = ({ value, stats, onChange, disabled }) => (
  <div data-testid="plan-mode-picker" className="mb-6 space-y-2">
    <p className="font-mono text-xs uppercase tracking-wider text-[#9CA3AF]">Tipo de otimização · peças com “seguir veio” não giram</p>
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
      {MODES.map(([k, l, d]) => (
        <button key={k} type="button" data-testid={`plan-mode-${k}`} disabled={disabled} onClick={() => onChange(k)}
          className={`rounded-lg border px-4 py-3 text-left transition-colors disabled:opacity-50 ${value === k ? "border-[#E67E22] bg-[#E67E22]/15" : "border-[#2D333F] hover:bg-[#21252F]"}`}>
          <div className="flex items-baseline justify-between gap-2">
            <p className="text-sm font-semibold">{l}</p>
            {stats?.[k] && <span data-testid={`plan-mode-usage-${k}`} className="font-mono text-sm font-bold text-[#10B981]">{pct(stats[k].usage)}</span>}
          </div>
          <p className="text-xs text-[#9CA3AF]">{d}{stats?.[k] ? ` · ${stats[k].sheets} chapa${stats[k].sheets > 1 ? "s" : ""}` : ""}</p>
          {stats?.[k] && <p data-testid={`plan-mode-sobra-${k}`} className="text-xs text-[#E67E22]">Maior sobra: {String(stats[k].biggest_sobra_m2).replace(".", ",")} m²</p>}
        </button>
      ))}
    </div>
  </div>
);

export const SheetModeSelect = ({ number, value, onChange }) => (
  <select data-testid={`sheet-mode-select-${number}`} value={value} disabled={!onChange} onChange={(e) => onChange(number, e.target.value)}
    className="rounded-md border border-[#2D333F] bg-[#0F1115] px-2 py-1 text-xs disabled:opacity-50">
    {MODES.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
  </select>
);
